import { useMemo } from 'react';

import {
  UseAutocompleteProps,
  UseDropdownProps,
} from '@adsk/alloy-react-dropdown';

import { DropdownProp, GroupedItem, ItemWithOptionalLabel } from '../types';

export default (
  dropdownProps:
    | DropdownProp<UseAutocompleteProps<ItemWithOptionalLabel>>
    | DropdownProp<UseDropdownProps<ItemWithOptionalLabel>>,
  groupedItems: GroupedItem[],
) => {
  const { selectedItem, defaultSelectedItem, initialSelectedItem } =
    dropdownProps;

  return useMemo(() => {
    const getSelectedItem = (itemToFind: ItemWithOptionalLabel) => {
      return (
        groupedItems
          .flatMap((groups) => groups.items)
          .find((i) => i.value === itemToFind.value) || null
      );
    };

    if (selectedItem) {
      return { selectedItem: getSelectedItem(selectedItem) };
    }
    if (defaultSelectedItem) {
      return { defaultSelectedItem: getSelectedItem(defaultSelectedItem) };
    }
    if (initialSelectedItem) {
      return { initialSelectedItem: getSelectedItem(initialSelectedItem) };
    }

    return {};
  }, [selectedItem, defaultSelectedItem, initialSelectedItem, groupedItems]);
};
